import ConfirmLessonsRequestModelBase from '../_generated/modelBases/confirm-lessons-request-model-base';

export default class ConfirmLessonsRequestModel extends ConfirmLessonsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
